import React from 'react'
import { CollaborationLegacy } from 'types/collaboration-legacy'
import userProfilePictrure from "../../../assets/images/users/user-dummy-img.jpg"
import { copyToClipboard } from 'utils/helpers'

const CollaborationCard: React.FC<{ collaboration: CollaborationLegacy }> = ({ collaboration }) => {
  return (
    <div className='card rounded-3 p-3 m-0 collaboration-card position-relative'>
      <div className='d-flex gap-3 align-items-center justify-content-between'>
        <div className='rounded-3 collaboration-campaign-image bg-image bgc-black' style={{ backgroundImage: `url(${collaboration.influencer?.social_account?.profile_picture_url ?? userProfilePictrure})` }}></div>
        <div className='w-75 d-flex flex-column'>
          <span className="text-muted collaboration-created-at">{collaboration.created}</span>
          <span className="pop collaboration-influencer-name text-truncate">{collaboration.influencer.name}</span>
          <div className="d-flex justify-content-start gap-2 align-items-center">
            <span className="text-dark collaboration-influencer-mobile">{collaboration.influencer.mobile}</span>
            <div className="d-flex justify-content-between align-items-center gap-2">
              <button className='unset-all' onClick={() => copyToClipboard(collaboration.influencer.mobile, "Mobile number copied to your clipboard!")}>
                <div className="avatar-xxs flex-shrink-0">
                  <div className="avatar-title bg-dark-subtle text-dark rounded-2 fs-17">
                    <i className="ri-file-copy-line"></i>
                  </div>
                </div>
              </button>
            </div>
          </div>
          <span className="collaboration-campaign text-dark">{collaboration.campaign.name}</span>
        </div>
      </div>
      <a href={`https://wa.me/91${collaboration.influencer.mobile}`} className='collaboration-wa-icon' target="_blank">
        <div className="avatar-xs flex-shrink-0">
          <div className="avatar-title bg-success text-white rounded-2 fs-20">
            <i className="ri-whatsapp-line"></i>
          </div>
        </div>
      </a>
    </div>
  )
}

export default CollaborationCard